import { Toaster } from "@/components/ui/sonner";
import { AddressProvider } from "@/contexts/AddressContext";
import Routers from "@/router";
import ScrollToTop from "@/router/ScrollToTop";
import store from "@/store";
import { ThemeProvider } from "next-themes";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import { UserProvider } from "./contexts/UserContext";

const APP_TITLE = "Redbird Management App";

export default function App() {
  return (
    <>
      <Provider store={store}>
        <ThemeProvider attribute="class" defaultTheme="light" enableSystem>
          <Router>
            <UserProvider unauthorized={<Routers.SessionRouter />}>
              <AddressProvider
                googleMapsApiKey={import.meta.env.VITE_APP_GOOGLE_API_KEY || ""}
              >
                <Toaster position="top-right" />
                <ScrollToTop />
                <HelmetProvider>
                  <Helmet>
                    <title>{APP_TITLE}</title>
                    <link
                      rel="icon"
                      type="image/x-icon"
                      href="/assets/img/favicon.ico"
                    />
                  </Helmet>
                  <Routers.AppRouter />
                </HelmetProvider>
              </AddressProvider>
            </UserProvider>
          </Router>
        </ThemeProvider>
      </Provider>
      <Toaster position="top-right" expand={false} richColors theme="light" />
    </>
  );
}
